import { useTranslations } from '@/i18n/use-translations';
import { PlusOutlined, SuccessFilled } from '@zeelool/icon';
import Image from '@/components/Image';
import { useScanInfo } from './useScanInfo';
import Upload from '@/components/Upload';
import { useOpticalProcedureTitle } from '@/app/_lens-components/copywriting/useOpticalProcedureTitle';

export default function ScanPrescriptionPC({
  // isShowPrismInfo,
  // setIsShowPrismInfo,
  onFileUpload,
  onClickUpload,
  onStartUpload,
}: {
  // isShowPrismInfo?: boolean,
  // setIsShowPrismInfo: (isShowPrismInfo: boolean) => void,
  onFileUpload?: (fileUrl: string) => void;
  onClickUpload?: (buttonType: 'Upload' | 'Photo') => void;
  onStartUpload?: () => void;
}) {
  const t = useTranslations('lens-process');
  const scanPrescriptionTitle = useOpticalProcedureTitle(
    'prescription_recognition',
    t('scanPrescription.title'),
  );
  const { incorrectExamples, prescriptionInfo } = useScanInfo('font-be');

  return (
    <div className="max-w-4xl mx-auto ">
      <div className="mb-[24px]">
        <div className="text-[20px]/[24px] font-be text-[#282828] mb-[16px]">
          {scanPrescriptionTitle}
        </div>
        <div className="font-br text-[#282828] text-[14px]/[18px] leading-relaxed">
          {t('scanPrescription.description')}
        </div>
      </div>

      {/* Upload Zone */}
      <Upload
        sceneId={2}
        fileType="image"
        accept="image/jpeg,image/png,image/jpg"
        className="!mt-0 mb-[32px]"
        toastConfig={{ success: false, fail: true }}
        sx={{
          '& .MuiBox-root': {
            width: '100%',
            height: '168px',
          },
        }}
        onClickUpload={() => {
          onClickUpload?.('Upload');
        }}
        onStartUpload={onStartUpload}
        onChange={onFileUpload}
      >
        <section
          className={`flex flex-col items-center bg-white justify-center border-1 border-dashed h-[168px] border-[#d4d4d4] rounded-xl p-12 text-center transition-colors cursor-pointer`}
        >
          <PlusOutlined className={`text-[30px] mb-[16px]`} />
          <div className="text-[#808080] text-[12px]/[14px]">
            <div>{t('scanPrescription.uploadZone.title')}</div>
            <div className="mt-[4px]">{t('scanPrescription.uploadZone.limit')}</div>
          </div>
        </section>
      </Upload>

      {/* Information Grid */}
      <section className="grid grid-cols-2 gap-16">
        {/* Prescription Example */}
        <div className="space-y-4">
          <div className="rounded-lg bg-cover bg-center relative shadow-sm">
            <Image src="/lens-process/correct-example.png" alt="" width={352} height={136} />
            <SuccessFilled className="absolute top-[6px] right-[6px] text-[30px] border-2 rounded-full border-white bg-white text-[#299373]" />
          </div>
        </div>

        {/* Requirements */}
        <div className="flex flex-col gap-[12px] py-[6px]">
          {prescriptionInfo.map((info, index) => (
            <div key={index} className="text-14 text-[#282828]">
              {info}
            </div>
          ))}
        </div>
      </section>

      {/* Incorrect Examples */}
      <section className="mt-[32px]">
        <div className="flex items-center gap-2 mb-[16px]">
          <div className="w-[18px] h-[18px] bg-[#bc1b1b] rounded-full text-white text-bold  flex items-center justify-center">
            <div className="w-[10px] h-[2px] bg-white " />
          </div>
          <span className="text-16 font-be  ml-[8px]">{t('scanPrescription.incorrectTitle')}</span>
        </div>

        <div className="grid grid-cols-3 gap-12">
          {incorrectExamples.map((example, index) => (
            <div key={index} className="h-[126px] rounded-lg relative overflow-hidden shadow-sm">
              <Image src={example.image} alt={example.label} fill className="object-cover" />
              <div className="absolute text-[14px] w-full bottom-0 bg-[rgba(0,0,0,0.5)] text-white text-sm text-center py-8 z-10">
                {example.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Prism Notice */}
      <section className="mt-[32px] rounded-[6px] ">
        <div className="flex justify-between items-center mb-[12px]">
          <div className="text-16 font-be">{t('havePrismValues')}</div>
          {/* <CollapseArrowDownOutlined className="w-16 h-16 text-[#808080]" /> */}
        </div>
        <div className="text-14 text-[#808080]">
          {t('theScanCannotCapturePrismValuesPleaseManuallyInputBasedOnYourPrescriptionIfNoted')}
        </div>
      </section>
    </div>
  );
}
